/* src/app/main/sat/sat.component.css */
.bg-img {
  background-position: center;
  background-size: cover;
  padding-top: 210px;
  padding-bottom: 80px;
}
.bg-img .bg-blue {
  background-color: rgb(48 67 96 / 0.79);
  padding-top: 25px;
  padding-bottom: 25px;
}
.bg-img .bg-blue .sat-logo {
  width: 60%;
  height: auto;
}
.bg-img .bg-blue img {
  width: 50px;
  height: 50px;
  margin-bottom: 10px;
}
.bg-img .bg-blue h5 {
  font-size: 19px;
  line-height: 27px;
}
.bg-img .bg-blue .col:before {
  content: "";
  position: absolute;
  width: 1px;
  height: 100%;
  background-color: rgb(255 255 255 / 0.2);
  left: -27px;
}
.bottom-footer {
  background-color: #213654;
  padding-top: 10px;
  padding-bottom: 10px;
}
@media (min-width: 1024px) {
  .bottom-footer .footer-links {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .bottom-footer .footer-links ul {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 0px;
  }
  .footer-last-col {
    max-width: 14.666667%;
  }
}
.bottom-footer .footer-links ul li {
  list-style: none;
  font-size: 14px;
  padding-right: 20px;
  font-weight: 300;
}
.footer-logo {
  width: 27%;
}
.footer-logo:not(:last-child) {
  margin-right: 30px;
}
.img-col .footer-logo {
  padding-top: 35px;
}
.services-links {
  padding-left: 0;
  list-style: none;
  display: flex;
  margin-bottom: 0px;
  padding-top: 8px;
}
.scan-logo {
  width: 70%;
}
.services-links li {
  padding-bottom: 12px;
  font-size: 17px;
  font-family: "D-DIN-Bold";
}
.services-links li a {
  color: #2C2C2C;
  text-decoration: underline;
  font-size: 15px;
  font-family: "D-DIN-Bold";
}
.services-links li a:hover {
  color: #E8882D;
}
.part-of-text {
  font-size: 14px;
  font-family: "Roboto", sans-serif;
}
.footer-main-row {
  padding-top: 40px;
  padding-bottom: 40px;
}
@media (min-device-width: 1600px) {
  .bg-img .bg-blue h5 {
    font-size: 26px;
    line-height: 40px;
  }
  .bg-img .bg-blue .sat-logo {
    width: 60%;
    height: auto;
  }
  .bg-img .bg-blue img {
    width: 60px;
    height: 60px;
  }
  .services-links li {
    font-size: 22px;
  }
  .services-links li a {
    font-size: 19px;
  }
  .bottom-footer .footer-links ul li {
    font-size: 16px;
  }
}
@media (min-device-width: 1440px) and (max-device-width: 1599px) {
  .bg-img .bg-blue h5 {
    font-size: 24px;
    line-height: 38px;
  }
  .bg-img .bg-blue .sat-logo {
    width: 60%;
    height: auto;
  }
  .bg-img .bg-blue img {
    width: 55px;
    height: 55px;
  }
  .services-links li {
    font-size: 19px;
  }
  .services-links li a {
    font-size: 17px;
  }
  .bottom-footer .footer-links ul li {
    font-size: 15px;
  }
}
@media (device-width: 1280px) {
  .services-links li {
    font-size: 16px;
  }
}
@media (device-width: 1024px) {
  .footer-logo:not(:last-child) {
    margin-right: 25px;
  }
  .services-links li {
    font-size: 14px;
  }
}
@media (device-width: 768px) {
  .bg-img .bg-blue .sat-logo {
    width: 75%;
  }
  .bg-img .bg-blue .col:before {
    left: -15px;
  }
}
@media (max-width: 767px) {
  .res-d-block {
    display: block !important;
  }
  .res-ps-0 {
    padding-left: 0px !important;
  }
  .res-none {
    display: none;
  }
  .bg-img .bg-blue h5 {
    font-size: 15px;
  }
  .bg-img .bg-blue .col:before {
    left: -11px;
  }
  .bg-img .bg-blue .sat-logo {
    width: 80%;
    margin-bottom: 30px;
  }
  .bg-img {
    padding-top: 150px;
  }
}
.border-left {
  border-left: 1px solid #ffffff33;
}
/*# sourceMappingURL=sat.component.css.map */
